import { IActivityComponent } from "@hulanbv/platformapp";
import { CrudService } from "nest-utilities-client";
import { httpService } from "../common/http.service";
import { environment } from "../../constants/environment.constants";

class Service extends CrudService<IActivityComponent> {
  constructor() {
    super([environment.apiUrl, "activity-components"].join("/"), httpService);
  }
}

export const activityComponentsService = new Service();
